const state = {
    selectedItemIndex: null,
    navData: [],
}

const getters = {}

const mutations = {
    setNavData(state, navData) {
        state.navData = navData
    },
    setSelectedItemIndex(state, itemIndex) {
        state.selectedItemIndex = (itemIndex === state.selectedItemIndex) ? null : itemIndex
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}